<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <!-- 저장하기 버튼 -->
        <div class="btn-group-justify-end">
          <div class="button is-primary" @click="saveCats">저장하기</div>
        </div>
        <div class="box">
          <admin-box-item title="전체 카테고리 목록"
                          :useTab="false"
                          subtitle="*카테고리를 이동시킬 경우 저장하기를 눌러주세요.
                                    *카테고리를 삭제하면 복구가 불가능합니다.">
            <div style="overflow-y: auto">
              <div style="height: 450px">
                <!-- 1차 카테고리 -->
                <draggable element="ul" :list="categories" :options="{group:'cat', ghostClass:'ghost'}" class="dragArea">
                  <li v-for="(cat,idx) in categories" v-bind:key="'cat'+idx">
                    <div class="lp-cat-item">
                      <div>{{ cat.name }}
                        <span v-for="(pack,idx) in cat.packages" v-if="cat.packages">({{ convertPackName(pack) }}<span v-if="idx < cat.packages.length-1">,</span>)</span></div>
                      <!--<div class="div-count">{{ cat.child.length }}</div>-->
                      <div :style="'background-image:url('+cat.img_before+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="cat.img_before"></div>
                      <div :style="'background-image:url('+cat.img_after+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="cat.img_after"></div>
                      <div style="flex:1"></div>
                      <button class="button half" @click="selCategory(cat)" style="margin-right:4px" v-if="cat.id>0">수정</button>
                      <button class="button half is-danger" @click="delCategory(categories, idx)">삭제</button>
                    </div>
                  <!--
                    &lt;!&ndash; 2차 카테고리 &ndash;&gt;
                    <draggable element="ul" :list="cat.child" :options="{group:'cat', ghostClass:'ghost'}" class="dragArea">
                  <li v-for="child,child_idx in cat.child" v-bind:key="'child'+child_idx">
                    <div class="lp-cat-item">
                      <div>{{ child.name }}</div><div class="div-count">{{ child.child.length }}</div>
                      <div :style="'background-image:url('+child.img_before+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="child.img_before"></div>
                      <div :style="'background-image:url('+child.img_after+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="child.img_after"></div>
                      <div style="flex:1"></div>
                      <button class="button half" style="margin-right:4px" @click="selCategory(child)" v-if="child.id>0">수정</button>
                      <button class="button half is-danger" @click="delCategory(cat.child, child_idx)">삭제</button>
                    </div>

                    &lt;!&ndash; 3차 카테고리 &ndash;&gt;
                    <draggable element="ul" :list="child.child" :options="{group:'cat', ghostClass:'ghost'}" class="dragArea">
                  <li v-for="grandson,grandson_idx in child.child" v-bind:key="'grandson'+grandson_idx">
                    <div class="lp-cat-item">
                      <div>{{ grandson.name }}</div><div class="div-count">{{ grandson.child.length }}</div>
                      <div :style="'background-image:url('+grandson.img_before+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="grandson.img_before"></div>
                      <div :style="'background-image:url('+grandson.img_after+')'" style="width:25px;height:25px;background-repeat:no-repeat;background-size:cover" v-if="grandson.img_after"></div>
                      <div style="flex:1"></div>
                      <button class="button half" style="margin-right:4px" @click="selCategory(grandson)" v-if="grandson.id>0">수정</button>
                      <button class="button half is-danger" @click="delCategory(child.child, grandson_idx)">삭제</button>
                    </div>
                  -->
                  </li>
                </draggable>

                </li>
                </draggable>
                </li>
                </draggable>
              </div>
            </div>
            <div class="btn-add-category" @click="addCategory">+ 새 카테고리 추가</div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <sweet-modal ref="categoryModal">
      <admin-box-item title="카테고리 수정" :useTab="false" v-if="value!==undefined">
        <div class="columns is-multiline">
          <div class="column is-7">
            <admin-form-item label="카테고리 명">
              <input class="input"
                     :value="value.name"
                     @input="e => value.name = e.target.value"
                     type="text">
            </admin-form-item>
          </div>

          <div class="column is-7">
            <admin-form-item label="설명">
              <input class="input"
                     :value="value.desc"
                     @input="e => value.desc = e.target.value"
                     type="text">
            </admin-form-item>
          </div>

          <div class="column is-full">
            <div class="columns is-multiline">
              <div class="column is-one-quarter">
                <admin-form-item label="기본 이미지">
                  <input-img :url.sync="value.img_before" :idx="1231231111"></input-img>
                </admin-form-item>
              </div>
              <div class="column is-one-quarter">
                <admin-form-item label="마우스오버 이미지">
                  <input-img :url.sync="value.img_after" :idx="1231246111"></input-img>
                </admin-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-group-justify-end">
          <div class="button is-primary" @click="saveCatUpdate">저장하기</div>
        </div>
      </admin-box-item>
    </sweet-modal>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import LpDropdown from "../../module/common/LpDropdown";
  import { SweetModal } from 'sweet-modal-vue'
  import InputImg from "../../module/common/InputImg";
  export default {

    components: {
      InputImg,
      LpDropdown,
      draggable,
      SweetModal
    },
    created() {
      this.getCats();
    },
    data() {
      return {
        categories: [],
        value: {}
      }
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getCats();
        }
      }
    },
    methods: {
      //카테고리 목록 가져오기
      getCats() {
        this.$axios.get(this.getUrl('board/category')).then(res=>{
          this.categories = res.data;

          if(this.categories.length===0){
            let cat = {
              id:0,
              name:'기본',
              desc:'',
              img:'',
              count:0,
              child:[]
            }
            this.categories.push(cat);
          }
          this.$store.commit('setLoading', false);
        })
      },
      // 카테고리 선택
      selCategory(cat) {
        this.value = cat;
        this.$refs.categoryModal.open();
      },
      addCategory() {
        this.categories.push({
          id: 0,
          name: '기본',
          desc: '',
          img: '',
          count: 0,
          child:[]
        })
        this.saveCats('add');
      },
      delCategory(cat, idx) {
        if(cat[idx].id===0) {
          removeIndex(cat,idx);
        }
        else {
          this.$axios.delete(this.getUrl('board/category/'+cat[idx].id))
            .then(res => {
              if(res.status===200) {
                this.toast('카테고리가 삭제되었습니다.');
                removeIndex(cat,idx);
              }
            });
        }
      },
      saveCats(type) {
        this.$store.commit('setLoading', true);
        this.$axios.post(this.getUrl('board/category'),{
          categories: this.categories,
        })
          .then(res => {
            if(type==='add') this.toast('새 카테고리를 추가했습니다.');
            else this.toast('저장되었습니다.');
            this.getCats();
          }).catch(error => {
          this.$store.commit('setLoading', false);
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        });
      },
      // 카테고리 상세정보 가져오기
      getCatDetail(){
        this.$axios.get(this.getUrl('board/category/' + this.value.id)).then(res=>{
          this.value = res.data;
        })
      },
      // 수정하기
      saveCatUpdate() {
        this.$axios.patch(this.getUrl('board/category/'+this.value.id), this.value)
          .then(res => {
            this.toast('저장되었습니다.');
            this.$refs.categoryModal.close();
          });
      },
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  @import '~assets/css/lp_main'

  ul
    list-style-type none

  .box
    overflow-y auto
  //max-height 500px

  .lp-row-title
    color #064160
    font-size 1.1rem
    border-bottom 1px solid #555
    padding-bottom 8px
    margin-bottom 20px

  .lp-total-title
    color #064160
    font-size 0.9rem
    margin auto 0

  .ghost
    opacity .5
    background-color #c8ebfb

  .dragArea
    padding 5px 0
    padding-left 20px
    /*min-height 20px*/

  .div-count
    border-radius 30px
    background-color #555
    color white
    font-size 0.7rem
    text-align center
    margin-left 8px
    width 18px
    height 18px
    line-height 18px

  .lp-cat-item-total
    box-sizing border-box
    display flex
    justify-content space-between
    margin-top 20px
    margin-bottom 8px
    padding 12px 8px
    width 100%
    background-color #eceeef
    color #555
    font-size 0.9rem

  .lp-cat-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px
  .lp-cat-item div
    margin auto 0
    margin-right 8px
  .lp-cat-item div:last-child
    margin-right 0

  .btn-add-category
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  label
    color #064160
    font-size 0.8rem

  .lp-content input
    margin-top 4px
    margin-left 8px
    border 0
    padding 4px 12px
    background #f2f6f8
    font-size 0.9rem

  .lp-cat-btn
    color #787878
    border 1px solid #787878
    margin-top 16px
    margin-right 8px
    border-radius 3px
    padding 4px 20px
    font-size 0.9rem
    text-align center
    display inline-block

  .lp-cat-btn.select
    border 1px solid $primary
    color $primary

  .btn-update
    margin-bottom 0
</style>
